import { forwardRef } from "react";
import ReactSelect, { ClassNamesConfig, Props, components } from 'react-select';
import { twMerge } from "tailwind-merge";
import { badgeControlStyles, controlStyles, disabledControlStyles, styles } from "./styles";
import { replacePeriodToUnderscore } from "@/common/utils/transformers";

export interface SelectProps extends Props {
  label?: string,
  markAsRequired?: boolean;
  labelIcon?: JSX.Element;
  disabled?: boolean,
  options?: { label: string | JSX.Element, value: number | string | null, isDisabled?: boolean; }[];
  badge?: boolean;
  dataTestid?: string,
  customStyles?: ClassNamesConfig<unknown>;
}

const Select = forwardRef<HTMLElement, SelectProps>(({
  label,
  markAsRequired,
  labelIcon,
  className,
  disabled = false,
  options = [],
  placeholder = 'Selecione',
  badge = false,
  name,
  noOptionsMessage,
  dataTestid,
  customStyles,
  ...props
}) => {
  const MenuList = (props: any) => {
    return (
      <div
        onWheel={(e) => e.stopPropagation()}
      >
        <components.MenuList {...props}>
          {props.children}
        </components.MenuList>
      </div>
    );
  };

  return (
    <div className={twMerge(className)}>
      <label
        className={twMerge("relative flex flex-col items-start justify-center",)}
        id={dataTestid || (name ? replacePeriodToUnderscore(name) + '_selector' : '')}
        data-testid={dataTestid || (name ? replacePeriodToUnderscore(name) + '_selector' : '')}
      >
        {label && (
          <div className="flex items-center gap-x-2 mb-1" data-test-role="label">
            <p className={twMerge('text-xs', disabled ? 'text-neutral-4' : '')}>
              {label}
              {markAsRequired && (
                <span className="text-danger-soft"> *</span>
              )}
            </p>

            {labelIcon}
          </div>
        )}
        <ReactSelect
          components={{
            MenuList,
          }}
          options={options}
          styles={styles}
          classNames={customStyles || (badge ? badgeControlStyles : ((disabled || props.isDisabled) ? disabledControlStyles : controlStyles))}
          noOptionsMessage={!!noOptionsMessage ? noOptionsMessage : () => 'Nenhuma opção'}
          placeholder={placeholder}
          name={name}
          menuPlacement="auto"
          menuPosition="absolute"
          menuPortalTarget={document.body}
          {...props} />
      </label>
    </div>
  )
});

export default Select;
